/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Gallery_Desc_Googledrive1Inputs */



/**
* | output |
* | --- |
* | "Sync folders and documents from Google Drive." |
*
* @param {Spaces_Gallery_Desc_Googledrive1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const spaces_gallery_desc_googledrive1 = /** @type {((inputs?: Spaces_Gallery_Desc_Googledrive1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Gallery_Desc_Googledrive1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ordner und Dokumente aus Google Drive synchronisieren.")
	return /** @type {LocalizedString} */ ("Sync folders and documents from Google Drive.")
});
export { spaces_gallery_desc_googledrive1 as "spaces_gallery_desc_googleDrive" }